import type { BaseController } from '@infra/controllers/base.controller';
import type { Contact } from '@salesforce/scv-connector-base';
import type { ShowAgentListUsecase } from './show-agentlist.usecase';

export type ShowAgentListInput = void;

export type ShowAgentListOutput = Contact[] | void;

export class ShowAgentListController
  implements BaseController<ShowAgentListInput, ShowAgentListOutput>
{
  constructor(private usecase: ShowAgentListUsecase) {}

  async handle(): Promise<ShowAgentListOutput> {
    return this.usecase.run();
  }
}
